import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';

import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { GuardModalEvent } from '@ui/misc/guard-modal/guard-modal.event';
import { OpenPopinOriginator } from '@common/enum/open-popin-originator.enum';

import { GuardModalService } from '../guard-modal/guard-modal.service';
import { GuardModalConfig } from '../guard-modal/guard-modal.config';

export abstract class PopinComponentBase
{
    protected openPopinOriginator: OpenPopinOriginator;
    abstract onClosePopin (): void;

    /**
     * @constructor
     * @param {Store<IAuroraState>} store
     * @param {GuardModalService} guardModalService
     */
    constructor (
        protected guardModalService: GuardModalService
    )
    { }

    /**
     * @param {GuardModalConfig} config - Configuration de la modale (textes,...)
     * @returns {Observable<boolean>} true : j'accepte de quitter et de tout perdre | false: je ne ferme pas le popin
     */
    preventClosePopinForm (config?: GuardModalConfig, status: boolean = false): Observable<boolean>
    {
        if (status)
        {
            return this.guardModalService.open(config)
                .onModalClosed
                .pipe(
                    map((guardModalEvent: GuardModalEvent) =>
                        guardModalEvent.dialogResult
                    )
                );
        }
        else
        {
            return of(true);
        }
    }

    protected markControlsDirty (form: UntypedFormGroup | UntypedFormArray): void
    {
        for (const ctrlKey in form.controls)
        {
            const abstractControl = form.controls[ctrlKey];

            if (abstractControl instanceof UntypedFormGroup || abstractControl instanceof UntypedFormArray)
            {
                this.markControlsDirty(abstractControl);
            }
            else
            {
                abstractControl.markAsDirty();
                abstractControl.markAsTouched();
            }
        }
    }
}
